import React from 'react';
import { Shield, Target, Users, Award, Clock, Lightbulb } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'Guaranteed Results',
      description: 'We assure timely delivery and inventory clearance within agreed timelines'
    },
    {
      icon: <Target className="w-6 h-6" />,
      title: 'Proven Track Record',
      description: '7 successful projects with 98% client satisfaction rate'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Expert Team',
      description: 'Experienced professionals in real estate, architecture, and construction'
    },
    {
      icon: <Award className="w-6 h-6" />,
      title: 'Quality Assurance',
      description: 'Highest standards in design, planning, and execution'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Timely Delivery',
      description: 'On-schedule project completion with milestone tracking'
    },
    {
      icon: <Lightbulb className="w-6 h-6" />,
      title: 'Innovative Solutions',
      description: 'Creative approaches to maximize value and minimize costs'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="gradient-text">NOVA HOMES</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your trusted partner for comprehensive real estate and construction solutions
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 card-hover"
              data-testid={`reason-card-${index}`}
            >
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center text-gray-900 mb-4">
                {reason.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{reason.title}</h3>
              <p className="text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;